import { render, staticRenderFns } from "./PricePopover.vue?vue&type=template&id=405eddba&scoped=true"
import script from "./PricePopover.vue?vue&type=script&lang=js"
export * from "./PricePopover.vue?vue&type=script&lang=js"
import style0 from "./PricePopover.vue?vue&type=style&index=0&id=405eddba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405eddba",
  null
  
)

export default component.exports